import * as XLSX from 'xlsx'
import { formatDate } from '../../../lib/helpers'
import {
    getPlayers,
    getPlayersClubsBatch,
    getClubsByUuids,
    getValidMedicalsBatch,
} from '../../../lib/api'

const EXTRA_POPULATE =
    '&populate[3]=gender&populate[4]=citizenship.citizenship_type'

const CSV_HEADERS = [
    'ID takmičara',
    'Ime i prezime',
    'Datum rođenja',
    'Pol',
    'Email',
    'Kontakt telefon',
    'Klub',
    'Lekarski pregled',
    'Stranac',
]

const buildRows = async (filterParams, searchInputId) => {
    const search = document.getElementById(searchInputId)
    const given_name = search?.value?.split(' ')[0] || ''
    const family_name = search?.value?.split(' ')[1] || ''

    const { competitors } = await getPlayers(
        [],
        { given_name, family_name },
        filterParams,
        1,
        true,
        false,
        EXTRA_POPULATE
    )

    if (!competitors?.length) return []

    const playerUuids = competitors.map((p) => p?.attributes?.uuid).filter(Boolean)

    const [playerClubEntries, validMedicals] = await Promise.all([
        getPlayersClubsBatch(playerUuids),
        getValidMedicalsBatch(playerUuids),
    ])

    const playerClubMap = {}
    playerClubEntries.forEach((pc) => {
        const playerUuid = pc?.attributes?.player_uuid
        if (playerUuid && !playerClubMap[playerUuid]) {
            playerClubMap[playerUuid] = pc?.attributes?.club_uuid
        }
    })

    const uniqueClubUuids = [...new Set(Object.values(playerClubMap).filter(Boolean))]
    const clubs = await getClubsByUuids(uniqueClubUuids)
    const clubNameMap = {}
    clubs.forEach((c) => {
        clubNameMap[c?.attributes?.uuid] = c?.attributes?.name
    })

    const validMedicalSet = new Set(
        validMedicals.map((m) => m?.attributes?.member_uuid)
    )

    return competitors.map((player) => {
        const attrs = player?.attributes
        const uuid = attrs?.uuid || '-'
        const name =
            `${attrs?.person_info?.given_name || ''} ${attrs?.person_info?.family_name || ''}`.trim() || '-'
        const birthdate = attrs?.person_info?.birthdate
            ? formatDate(attrs.person_info.birthdate)
            : '-'
        const gender = attrs?.gender?.gender_name || '-'
        const email = attrs?.person_info?.email || '-'
        const phone = attrs?.person_info?.phone || '-'
        const clubUuid = playerClubMap[uuid]
        const clubName = clubUuid ? clubNameMap[clubUuid] || '-' : '-'
        const hasMedical = validMedicalSet.has(uuid) ? 'Da' : 'Ne'
        const citizenshipType =
            attrs?.citizenship?.citizenship_type?.citizenship_type_name
        const isForign = citizenshipType === 'Strano' ? 'Da' : 'Ne'

        return [uuid, name, birthdate, gender, email, phone, clubName, hasMedical, isForign]
    })
}

const filename = (ext, count) =>
    `Takmičari - Ukupno-${count}, ${formatDate(new Date()).slice(0, -1)}.${ext}`

export const exportExcel = async (filterParams, searchInputId, setIsLoading) => {
    setIsLoading(true)
    try {
        const rows = await buildRows(filterParams, searchInputId)
        const worksheet = XLSX.utils.aoa_to_sheet([CSV_HEADERS, ...rows])
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Takmičari')
        XLSX.writeFile(workbook, filename('xlsx', rows.length))
    } finally {
        setIsLoading(false)
    }
}

export const exportCSV = async (filterParams, searchInputId, setIsLoading) => {
    setIsLoading(true)
    try {
        const rows = await buildRows(filterParams, searchInputId)
        const data = [CSV_HEADERS, ...rows]
        const csvContent = data
            .map((row) =>
                row
                    .map((cell) => `"${String(cell).replace(/"/g, '""')}"`)
                    .join(',')
            )
            .join('\r\n')

        const blob = new Blob(['﻿' + csvContent], {
            type: 'text/csv;charset=utf-8;',
        })
        const link = document.createElement('a')
        link.setAttribute('href', URL.createObjectURL(blob))
        link.setAttribute('download', filename('csv', rows.length))
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    } finally {
        setIsLoading(false)
    }
}
